module.exports = __webpack_public_path__ + "img/res-icon-40.b3161e11.png";